import { addSceneBackgroundDots } from '../components/background-dots';
import { addChildCircle } from '../components/child';
import { addNpcCrowd } from '../components/npc-circle';
import { addPlayerCircle } from '../components/player';
import { addSceneWalls } from '../components/wall';
import { Colors } from '../constants/colors';
import { GAME_HEIGHT, GAME_WIDTH } from '../constants/constants';
import { Scenes } from '../constants/scenes';
import { Tags } from '../constants/tags';
import { crowdMusic, mainMusic } from '../main';
import { GameState } from '../types/game-state';

export function crowdScene() {
  scene(Scenes.CROWD, (gameState: GameState) => {
    const SCENE_WIDTH = GAME_WIDTH * 3;
    const SCENE_HEIGHT = GAME_HEIGHT * 3;
    debug.log('in crowd scene');

    // Start looping music (only once, or if it was stopped externally)
    mainMusic.stop();
    crowdMusic.play();

    add([
      // make them not random, but follow a grid that is evenly spaced
      pos(0, 0),
      color(...Colors.GREEN),
      circle(1),
    ]);

    // add the walls of the map to prevent NPC and the player from leaving the
    // play area
    addSceneWalls({ sceneHeight: SCENE_HEIGHT, sceneWidth: SCENE_WIDTH });

    // draw dots in the background to give a sense of movement/reference
    addSceneBackgroundDots({
      sceneHeight: SCENE_HEIGHT,
      sceneWidth: SCENE_WIDTH,
      spacing: 100,
    });
    // draw the NPCs

    addNpcCrowd({
      sceneHeight: SCENE_HEIGHT,
      sceneWidth: SCENE_WIDTH,
      gameState,
      // **Note** this could be a density setting and passed in.
      numNpcs: 50,
    });

    // draw the child

    const playerColor = Colors[gameState.playerColor];
    addChildCircle({
      pos: vec2(SCENE_WIDTH / 2, SCENE_HEIGHT - 120),
      color: rgb(...(playerColor as [number, number, number])),
      sceneWidth: SCENE_WIDTH,
      sceneHeight: SCENE_HEIGHT,
      gameState,
    });

    // draw the player
    const player = addPlayerCircle({
      color: rgb(...(playerColor as [number, number, number])),
      // the player always start at the bottom middle of the screen
      pos: vec2(SCENE_WIDTH / 2, SCENE_HEIGHT - 64),
    });

    // Show win message once on collision between player and child

    // Use tag-based collision (child has Tags.KID, player has Tags.PLAYER)
    player.onCollide(Tags.KID, () => {
      crowdMusic?.stop();
      mainMusic.play();
      go(Scenes.GAME_OVER, gameState);
    });
  });
}
